import styled from '@emotion/styled';
import {
  focusVisibleStyles,
  preventFocusVisibleStyleClipping,
  pxToRem,
  Text,
} from '@lbcamden/lib-react';
import { Content, Root, Trigger } from '@radix-ui/react-collapsible';

import { animateCollapsibleContent } from '~/client/style/mixins';

export const CollapsibleRoot = styled(Root)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const CollapsibleTrigger = styled(Trigger)`
  ${focusVisibleStyles('button')}

  all: unset;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: ${pxToRem(44)};
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.create('background-color')};

  &:hover {
    background-color: ${({ theme }) => theme.colors.backgroundHover};
  }

  svg {
    flex-shrink: 0;
    align-self: stretch;
    margin: ${pxToRem(14.5)};
    transition: ${({ theme }) => theme.transitions.create('transform')};
  }
`;

export const CollapsibleContent = styled(Content)`
  ${animateCollapsibleContent}
  ${preventFocusVisibleStyleClipping([0, 1, 1])}
`;

export const HeadingContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing([4, 8])};
  align-items: center;

  h3 {
    font-size: ${pxToRem(18)};
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const InfoHeading = styled(Text)`
  display: inline-flex;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  font-weight: 600;
`;

export const ResidentInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(8)};
`;

export const TopContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(8)};
  padding-top: ${({ theme }) => theme.spacing(4)};

  ${({ theme }) => theme.breakpoints.up('md')} {
    flex-direction: row;
    gap: ${({ theme }) => theme.spacing(4)};

    > ${ResidentInfo}, > ${InfoContainer} {
      flex: 1;
    }
  }
`;

export const ContainerDivider = styled.div`
  align-self: stretch;
  border-top: ${({ theme }) => theme.borderLight};

  ${({ theme }) => theme.breakpoints.up('md')} {
    border-top: none;
    border-left: ${({ theme }) => theme.borderLight};
  }
`;
